<template>
	<span class="new-alert-badge">{{ $t("overlay-menu.new") }}</span>
</template>

<script>
export default {
	name: "new-badge-indicator",
};
</script>

<style lang="scss" scoped>
.new-alert-badge {
	position: absolute;
	font-size: var(--font-tiny);
	font-weight: var(--font-weight-normal);
	text-transform: none;
	padding-top: 1px;
	color: var(--always-white);
	background: transparent url("../../assets/img/new_badge.png") no-repeat;
	background-size: 35px 16px;
	width: auto;
	min-width: 23px;
	height: 27px;
	text-align: center;
}

</style>
